import { StandardEvents, CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

/**
 * Muralys · Panier
 * Si le decor est retire du panier, la ligne « Poseur trouve pour vous » qui lui etait liee (meme _ref)
 * est retiree aussi : on ne vend jamais une pose seule.
 */
const POSE_TYPE = 'Service de pose';

async function reconcile() {
  const cart = await fetch('/cart.js').then((response) => response.json());
  const refs = new Set(
    cart.items.filter((item) => item.product_type !== POSE_TYPE && item.properties?._ref).map((item) => item.properties._ref)
  );
  const orphan = cart.items.find(
    (item) => item.product_type === POSE_TYPE && item.properties?._ref && !refs.has(item.properties._ref)
  );
  if (!orphan) return;

  const row = document.querySelector(`[data-key="${CSS.escape(orphan.key)}"]`);
  const button = row?.querySelector('.cart-items__remove');
  if (button) {
    button.click();
  } else {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: orphan.key, quantity: 0 }),
    });
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (event.action === 'add') return;
  event.promise?.then(() => setTimeout(reconcile, 500)).catch(() => {});
});

/**
 * Ajout de la pose depuis le panier : une ligne « Poseur trouve pour vous » liee au decor par le meme _ref.
 */
document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-muralys-add-pose]') : null;
  if (!button || button.getAttribute('aria-busy') === 'true') return;
  event.preventDefault();

  const items = [{ id: Number(button.dataset.variantId), quantity: 1, properties: { _ref: button.dataset.ref } }];
  const sections = [...document.querySelectorAll('cart-items-component')]
    .map((element) => /** @type {HTMLElement} */ (element).dataset.sectionId)
    .filter(Boolean)
    .join(',');

  button.setAttribute('aria-busy', 'true');
  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'cart',
      lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: item.quantity })),
      promise: deferred.promise,
    })
  );

  try {
    const response = await fetch(window.Theme?.routes?.cart_add_url ?? '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections }),
    }).then((r) => r.json());
    const cart = await fetch(`${window.Theme?.routes?.cart_url ?? '/cart'}.json`).then((r) => r.json());
    const failed = Boolean(response.status);
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'muralys-pose', itemCount: items.length, sections: response.sections, didError: failed },
    });
    if (failed) {
      button.dispatchEvent(new CartErrorEvent({ error: response.message || 'Add to cart failed', code: 'INVALID', detail: { description: response.description, errors: response.errors } }));
    }
  } catch (error) {
    deferred.reject(error);
    button.dispatchEvent(new CartErrorEvent({ error: error?.message || 'Network error', code: 'SERVICE_UNAVAILABLE' }));
  } finally {
    button.removeAttribute('aria-busy');
  }
});

/**
 * Date de livraison estimee (heure de Paris + jours reglables) sous le bouton de paiement.
 */
function fillDeliveryDates() {
  document.querySelectorAll('[data-mcd]').forEach((element) => {
    const days = parseInt(element.getAttribute('data-days') || '6', 10) || 6;
    const prefix = element.getAttribute('data-prefix') || 'Livraison estimée le';
    try {
      const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' })
        .format(new Date())
        .split('-');
      const target = new Date(Date.UTC(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]) + days, 12));
      const label = new Intl.DateTimeFormat('fr-FR', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' }).format(target);
      element.textContent = prefix;
      const strong = document.createElement('strong');
      strong.textContent = label;
      element.append(strong);
      element.hidden = false;
    } catch (error) {
      /* la date reste masquee */
    }
  });
}

let datesQueued = false;
new MutationObserver(() => {
  if (datesQueued) return;
  datesQueued = true;
  requestAnimationFrame(() => {
    datesQueued = false;
    fillDeliveryDates();
  });
}).observe(document.body, { childList: true, subtree: true });
fillDeliveryDates();
